import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../../../../utils/lazyImportRouteComponent"

export const Route = createFileRoute(
  "/app/admin-settings/users/new/external-service-user"
)({
  component: lazyImportRouteComponent(
    () => import("./-components/CreateExternalServiceUserPage"),
    "CreateExternalServiceUserPage"
  ),
  beforeLoad: (context) => {
    return {
      getTitle: () =>
        context.context.t && context.context.t("ExternalServiceUser"),
    }
  },
})
